// extracted by mini-css-extract-plugin
module.exports = {"active":"LanguagesDropdown_active__Zd_Px","menu":"LanguagesDropdown_menu__FvS2E","button":"LanguagesDropdown_button__K3o9x","title":"LanguagesDropdown_title__ZfUoo"};